export default {
  id: 87,
  title: 'Target #87 - Building Blocks',
  url: 'https://cssbattle.dev/play/87',
  colors: ['#F3AC3C', '#1A4341'],
  solution:
    '<a a><a b><a c><a d><style>[b],[c]{height:50;background:#1a4341}[a],[b],[c]{background:#1a4341}[b],[d]{width:70;border-radius:10px}[d],body{background:#f3ac3c}[a],[b],[d]{border-radius:10px}a{position:fixed}[a]{top:65;left:65;width:100;height:100;box-shadow:170px 70px #1a4341}[b]{top:65;left:145;box-shadow:40px 120px #1a4341}[c]{top:100;left:150;width:50;box-shadow:50px 50px #1a4341}[d]{top:115;left:165;height:70}</style>',
}
